import { Link, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function Layout() {
    const { user, logout } = useAuth();

    return (
        <div className="app-layout">
            <nav className="sidebar">
                <h3>Band Tracker</h3>
                <Link to="/">Songs</Link>
                <Link to="/calendar">Calendar</Link>
                <Link to="/equipment">Equipment</Link>
                <Link to="/gigs">Gigs</Link>
                <Link to="/contacts">Contacts</Link>
                <Link to="/messages">Messages</Link>
                {user?.role === 'admin' && <Link to="/settings">Settings</Link>}
                {user?.role === 'admin' && <Link to="/logs">Logs</Link>}
                <button onClick={logout}>Log Out</button>
            </nav>
            <main className="content">
                <Outlet />
            </main>
        </div>
    );
}
